import React, { Fragment } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Field } from 'redux-form-normalize-on-blur/index';
import { isJsonString } from 'common/utils';

import './index.css';

export const Checkbox = ({
  input,
  meta: { touched, error },
  label,
  className,
  theme,
  options,
  ...rest
}) => {
  const checkboxCSS = cn(
    'checkbox',
    className,
    theme ? theme.map(css => `checkbox--${css}`).join(' ') : ''
  );

  // for checkbox group
  if (options) {
    const { name, onChange } = input;
    const inputValue = input.value;
    const checkboxes = options.map(({ label, value }, index) => {
      const handleChange = event => {
        const arr = [...inputValue];
        if (event.target.checked) {
          arr.push(value);
        } else {
          arr.splice(arr.indexOf(value), 1);
        }
        return onChange(arr);
      };
      let checked = false;
      let hasCheckedSelected = false;

      if (isJsonString(value) && inputValue.length) {
        const valueObj = JSON.parse(value);
        inputValue.forEach(selectedValue => {
          if (isJsonString(selectedValue)) {
            const selectedValueObj = JSON.parse(selectedValue);
            if (
              selectedValueObj.id &&
              valueObj.id &&
              selectedValueObj.id === valueObj.id
            ) {
              hasCheckedSelected = true;
              checked = true;
            }
          }
        });
      }

      if (!hasCheckedSelected) {
        checked = inputValue.includes(value);
      }

      return (
        <fieldset key={`checkbox-${index}`}>
          <label className={checkboxCSS}>
            <input
              type="checkbox"
              name={`${name}[${index}]`}
              value={value}
              checked={checked}
              onChange={handleChange}
            />
            <span className={cn('checkbox__mark')} />
            {label}
          </label>
        </fieldset>
      );
    });

    return (
      <Fragment>
        {checkboxes}
        {touched && error && <small className="text--error">{error}</small>}
      </Fragment>
    );

    // for single checkbox
  } else {
    return (
      <fieldset>
        <label className={checkboxCSS}>
          <input {...input} {...rest} type="checkbox" checked={input.value} />
          <span
            className={cn('checkbox__mark', {
              'checkbox__mark--error': touched && error,
            })}
          />
          {label}
        </label>
        {touched && error && <small className="text--error">{error}</small>}
      </fieldset>
    );
  }
};

const ConnectedCheckbox = ({
  component = Checkbox,
  className,
  name,
  options,
  ...rest
}) => {
  return (
    <Field
      {...rest}
      component={component}
      name={name}
      options={options}
      className={className}
    />
  );
};

Checkbox.propTypes = {
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  error: PropTypes.string,
  touched: PropTypes.bool,
  meta: PropTypes.object,
  input: PropTypes.object,
  options: PropTypes.arrayOf(PropTypes.object),
  theme: PropTypes.array,
};

Checkbox.displayName = 'Checkbox';

ConnectedCheckbox.propTypes = {
  className: PropTypes.string,
  component: PropTypes.element,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
};

export default ConnectedCheckbox;



// WEBPACK FOOTER //
// ./src/common/components/Checkbox/index.js